import { api, prefix } from "@/api";
import { AxiosRequestConfig } from "axios";

const namespace = "switchboard";

export interface CallLogPayload {
  extension?: string;
  // Null quando l'interno non risulta membro di nessuna coda: la barra ha sempre
  // scritto la riga anche in quel caso, la coda è un arricchimento accessorio.
  queue?: string | null;
  direction?: "incoming" | "outgoing";
  // Stringhe ISO sia in scrittura sia in lettura: `Date` era una descrizione
  // sbagliata di ciò che transita davvero sul filo (vedi la nota in
  // switchboardStatsMapping.mapCallLogToDetailRow, che gestisce entrambi i casi).
  startTime?: Date | string;
  endTime?: Date | string;
  duration?: number; // Seconds
  customer?: string;
  // Valori prodotti da mapOriginToTerminator (src/sip/sip-call-manager.ts:13):
  // 'operator' | 'customer' | 'system' | 'unknown'.
  // I valori SIP grezzi ('local', 'remote-bye', 'remote-reject', 'timeout', 'error') non
  // arrivano mai qui: la normalizzazione esiste dal primo commit che scrive il call-log.
  terminatedBy?: string;
}

export interface CallLogResponse {
  data: CallLogPayload[];
  count: number;
}

export const createCallLog = async (
  data: CallLogPayload,
  config: AxiosRequestConfig = {}
): Promise<void> =>
  (await api<void>({
    url: `${prefix}/${namespace}/call-log`,
    method: "POST",
    data,
    ...config,
  })) as unknown as void;

export const getCallLogs = async (
  params: any,
  config: AxiosRequestConfig = {}
): Promise<CallLogResponse> =>
  (await api<CallLogResponse>({
    url: `${prefix}/${namespace}/call-log`,
    method: "GET",
    params,
    ...config,
  })) as unknown as CallLogResponse;
